// pages/FormViewerPage/hooks/useEmbedResize.ts — Kirim tinggi form ke parent (iframe embed)
import { useEffect } from 'react';

export function useEmbedResize(
    containerRef: any,
    isEmbed: boolean,
    identifier: string,
    isSimpleEmbed: boolean,
    herbalClaimMode: any,
    loading: any,
) {
    useEffect(() => {
        if (!isEmbed) return;
        const sendHeight = () => {
            const formEl = containerRef.current?.querySelector('form') || containerRef.current;
            if (!formEl) return;
            const rectHeight = Math.ceil(formEl.getBoundingClientRect().height);
            if (rectHeight <= 0) return;
            const height = Math.max(160, rectHeight + 12);
            try {
                window.parent?.postMessage({ type: 'cuanmax:form-resize', height, identifier }, '*');
            } catch { /* ignore cross-origin error */ }
        };

        // Kirim berkala sejak awal saat elemen & fonts/images masih loading
        sendHeight();
        const timers = [
            setTimeout(sendHeight, 50),
            setTimeout(sendHeight, 150),
            setTimeout(sendHeight, 350),
            setTimeout(sendHeight, 700),
            setTimeout(sendHeight, 1200),
            setTimeout(sendHeight, 2000),
        ];
        // Ulangi tiap 2 dtk selama 30 dtk pertama (tutup race: parent LP statis
        // bisa pasang listener belakangan — JS telat, hidrasi gagal, iframe reload).
        const repeat = setInterval(sendHeight, 2000);
        const stopRepeat = setTimeout(() => clearInterval(repeat), 30000);

        // Handshake listener: jika parent window me-request resize
        const handleParentMessage = (e: MessageEvent) => {
            if (e.data && (e.data.type === 'cuanmax:request-resize' || e.data.type === 'cuanmax:init')) {
                sendHeight();
            }
        };
        window.addEventListener('message', handleParentMessage);

        const ro = new ResizeObserver(() => {
            sendHeight();
        });

        if (containerRef.current) ro.observe(containerRef.current);
        const formEl = containerRef.current?.querySelector('form');
        if (formEl) ro.observe(formEl);

        window.addEventListener('resize', sendHeight);
        window.addEventListener('load', sendHeight);
        if (document.fonts?.ready) {
            document.fonts.ready.then(sendHeight).catch(() => {});
        }

        return () => {
            timers.forEach(clearTimeout);
            clearInterval(repeat);
            clearTimeout(stopRepeat);
            window.removeEventListener('message', handleParentMessage);
            ro.disconnect();
            window.removeEventListener('resize', sendHeight);
            window.removeEventListener('load', sendHeight);
        };
    }, [isEmbed, identifier, isSimpleEmbed, herbalClaimMode, loading]);
}
